module.exports = __webpack_public_path__ + "static/media/health.1eb590f1.png";